import React, { Component } from "react";

import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import PageDesigner from "../page_designer/PageDesigner";
import TemplateManager from "./templates/TemplateManager";
import { PAGE_TYPE } from "../page_designer/ComponentList";
import SavePopup from "../common/SavePopup";
import LandingPageManager from "./LandingPageManager";
import LandingPageService from "../../services/landingPage";
import LandingPageHeader from "./LandingPageHeader";
import ComponentManager from "../page_designer/ComponentManager";

export default class LandingPageBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSegment: 0,
      jsonData: LandingPageManager.isPageDataAvailable()
        ? LandingPageManager.getPageJSONData()
        : TemplateManager.getTemplate(),
      needSaveButton: true,
      needSavePopup: false,
      needSharePopup: false,
    };

    this.pageDataToSave = null;
    this.pageType = PAGE_TYPE.PEOPLE_EMAIL_TEMPLATE;
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    if (
      !LandingPageManager.isPageDataAvailable() &&
      this.props.match.params.id
    ) {
      this.setState({ jsonData: [] });
      LandingPageManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState({ jsonData: LandingPageManager.getPageJSONData() });
      });
    }
  }

  render() {
    return (
      <div className="parent-width align-items-start parent-height">
        <LandingPageHeader
          title={"Email Template Designer"}
          stepperIndex={1}
          onSave={this.saveTapped}
        />
        <PageDesigner
          type={this.pageType}
          components={
            Array.isArray(this.state.jsonData)
              ? this.state.jsonData
              : this.state.jsonData.designElements
          }
          scripts={this.state.jsonData.scripts}
          metaData={this.state.jsonData.metaData}
          hash={this.state.jsonData.hash}
          onDataChange={(data) => {
            this.pageDataToSave = data;
          }}
          onSave={() => {
            this.saveTapped();
          }}
        />
        {this.state.needSavePopup && this.getSavePopup()}
      </div>
    );
  }

  saveTapped = () => {
    if (LandingPageManager.isPageDataAvailable()) {
      this.updatePage();
    } else {
      this.showSavePopup();
    }
  };
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSavePopup() {
    return (
      <SavePopup
        title="New email template"
        header="Page Name"
        headerIcon="📝 "
        subHeader="Enter a name to help you remember what this email template is all about."
        onCancel={this.onPopupCancel}
        onSave={this.onPopupSave}
        allowDomainSelection={true}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSavePopup = () => {
    this.setState({
      needSavePopup: true,
    });
  };
  hideSavePopup = () => {
    this.setState({
      needSavePopup: false,
    });
  };

  //////////////////////////////////////////////////////

  onPopupSave = (title, domain) => {
    this.hideSavePopup();
    this.savePage(title, domain);
  };
  onPopupCancel = () => {
    this.hideSavePopup();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  savePage(title, domain) {
    let data = {
      ...ComponentManager.getEncodedDataToSave(
        this.pageDataToSave,
        this.pageType
      ),
      name: title,
      domain: domain,
    };

    const request = LandingPageManager.getRequestToSavePage(data);
    LandingPageService.save(
      request,
      (data) => {
        this.pageSaved(data);
      },
      (error) => {}
    );
  }

  updatePage() {
    const request = LandingPageManager.getRequestToUpdatePage(
      ComponentManager.getEncodedDataToSave(this.pageDataToSave, this.pageType)
    );
    LandingPageService.update(
      request,
      LandingPageManager.getPageRecordId(),
      (data) => {
        this.pageSaved(data);
      },
      (error) => {}
    );
  }

  pageSaved(data) {
    LandingPageManager.setPageData(data);
    RouteManager.navigateToPage(
      PAGE_ROUTES.LANDING_PAGE_DOMAIN +
        "/" +
        LandingPageManager.getPageRecordId()
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}
